import { Chip } from "@mui/material";

interface Props {
  /** The resolved Termin-Zweck label (see useAppointmentLabels). */
  label: string;
}

export function AppointmentPurposeChip({ label }: Props) {
  return <Chip label={label} size="small" color="primary" variant="outlined" />;
}
